/**
 * @generated SignedSource<<b219464a1556af369e4bc47dc297efd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GraphQLOnboardingTaskId = "CHAT_WITH_TIERZERO" | "CONNECT_CODE" | "CONNECT_DOCUMENTATION" | "CONNECT_MESSAGING" | "CONNECT_ONCALL" | "CONNECT_TELEMETRY" | "CREATE_AND_RUN_FIRST_DIGEST" | "CREATE_FIRST_ALERT_RESPONDER" | "INSPECT_INTEGRATION_RESOURCES" | "INTEGRATION_SETUP" | "KNOWLEDGE_SETUP" | "LEARN_ALERT_RESPONDER" | "LEARN_CHAT" | "LEARN_DIGEST" | "MANAGE_MEMORY" | "SETUP_INTEGRATIONS" | "SETUP_TEAM" | "TIERZERO_MD_SETUP" | "TIERZERO_USER_GUIDE" | "%future added value";
export type GraphQLOnboardingTaskStatusEnum = "COMPLETED" | "PENDING" | "TODO" | "TO_REVIEW" | "%future added value";
export type IntegrationStatusType = "APPROVED" | "PENDING" | "%future added value";
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type Kind = "DISCORD_WEBHOOK" | "SLACK_ALERT" | "SLACK_CHANNEL" | "%future added value";
export type DigestJobDetailsPageQuery$variables = {
  id: any;
};
export type DigestJobDetailsPageQuery$data = {
  readonly me: {
    readonly organization: {
      readonly discordWebhooks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: any;
            readonly name: string;
          };
        }>;
      };
      readonly id: any;
      readonly integrations: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly integrationStatus: IntegrationStatusType | null | undefined;
            readonly integrationType: IntegrationType;
          };
        }>;
      };
      readonly onboardingTaskStatuses: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: any;
            readonly status: GraphQLOnboardingTaskStatusEnum;
            readonly taskId: GraphQLOnboardingTaskId;
          };
        }>;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"appMe">;
  };
  readonly node: {
    readonly id?: any;
    readonly inputJson?: any;
    readonly name?: string;
    readonly notificationIntegrations?: ReadonlyArray<{
      readonly id: any;
      readonly kind: Kind;
      readonly name: string;
      readonly slackChannelId: string | null | undefined;
    }>;
    readonly team?: {
      readonly id: any;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"DigestJobInfo_job">;
  } | null | undefined;
  readonly slackChannels: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type DigestJobDetailsPageQuery = {
  response: DigestJobDetailsPageQuery$data;
  variables: DigestJobDetailsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLOnboardingTaskStatusConnection",
  "kind": "LinkedField",
  "name": "onboardingTaskStatuses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLOnboardingTaskStatusEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLOnboardingTaskStatus",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taskId",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLIntegrationConnection",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLIntegrationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLIntegration",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationStatus",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v1/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": "discordWebhooks",
  "args": [
    {
      "kind": "Literal",
      "name": "kind",
      "value": "DISCORD_WEBHOOK"
    }
  ],
  "concreteType": "GraphQLNotificationIntegrationConnection",
  "kind": "LinkedField",
  "name": "notificationIntegrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLNotificationIntegrationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLNotificationIntegration",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "notificationIntegrations(kind:\"DISCORD_WEBHOOK\")"
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "types",
      "value": "public_channel,private_channel"
    }
  ],
  "concreteType": "GraphQLSlackChannel",
  "kind": "LinkedField",
  "name": "slackChannels",
  "plural": true,
  "selections": (v6/*: any*/),
  "storageKey": "slackChannels(types:\"public_channel,private_channel\")"
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inputJson",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLNotificationIntegration",
  "kind": "LinkedField",
  "name": "notificationIntegrations",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slackChannelId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLTeam",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DigestJobDetailsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLUser",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appMe"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v8/*: any*/),
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*: any*/),
              (v5/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLTeam",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DigestJobInfo_job"
              }
            ],
            "type": "GraphQLJob",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DigestJobDetailsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLUser",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pictureUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuperAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brandTheme",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSuspended",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suspensionReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suspendedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creditLimitResetAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appUrlDomain",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingCompletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledFeatureFlags",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLUserTeamContext",
            "kind": "LinkedField",
            "name": "teamContext",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v8/*: any*/),
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v12/*: any*/),
              (v11/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedule",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nextRunAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLPromptFeedback",
                "kind": "LinkedField",
                "name": "latestPromptFeedback",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLPromptSuggestion",
                    "kind": "LinkedField",
                    "name": "suggestions",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isStale",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "GraphQLJob",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "98e80284efb5f97284b637fbace4b988",
    "id": null,
    "metadata": {},
    "name": "DigestJobDetailsPageQuery",
    "operationKind": "query",
    "text": "query DigestJobDetailsPageQuery(\n  $id: GlobalID!\n) {\n  me {\n    ...appMe\n    organization {\n      id\n      onboardingTaskStatuses {\n        edges {\n          node {\n            id\n            taskId\n            status\n          }\n        }\n      }\n      integrations {\n        edges {\n          node {\n            integrationType\n            integrationStatus\n          }\n        }\n      }\n      discordWebhooks: notificationIntegrations(kind: DISCORD_WEBHOOK) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n  slackChannels(types: \"public_channel,private_channel\") {\n    id\n    name\n  }\n  node(id: $id) {\n    __typename\n    ... on GraphQLJob {\n      id\n      name\n      inputJson\n      team {\n        id\n      }\n      notificationIntegrations {\n        id\n        name\n        kind\n        slackChannelId\n      }\n      ...DigestJobInfo_job\n    }\n    __isNode: __typename\n    id\n  }\n}\n\nfragment DigestJobInfo_job on GraphQLJob {\n  id\n  name\n  status\n  schedule\n  nextRunAt\n  team {\n    id\n    name\n  }\n  latestPromptFeedback {\n    id\n    suggestions {\n      name\n      isStale\n    }\n  }\n}\n\nfragment appMe on GraphQLUser {\n  id\n  email\n  firstName\n  lastName\n  pictureUrl\n  isSuperAdmin\n  role\n  scopes\n  organization {\n    id\n    name\n    brandTheme\n    isSuspended\n    suspensionReason\n    suspendedAt\n    creditLimitResetAt\n    appUrlDomain\n    onboardingCompletedAt\n    enabledFeatureFlags\n  }\n  teamContext {\n    id\n    team {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "72800385a292794281498f4c3f69c7c8";

export default node;
